import numeral from 'numeral'

export default integer

/** @ngInject */
function integer() {
    return function (value) {
        return numeral(value).format('0')
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/integer.js